module.exports = "<p>\n\tclosed-app works!\n  </p>"